import { navigate } from 'gatsby-link';
import { saveUTMsToCookies } from '@landr/core';
import { UTMCookieSettings } from '../constants';
import { SupportedLanguages } from '../types';
import { isHomePage as isHomePageHelper, getTwoLetterLanguageCode } from '../helpers';
import { PageDataType } from './Page';

function getAlternatePage(page: PageDataType, abbreviatedBrowserLanguage: any) {
    const alternatePage = page.alternate_languages.find(translatedPage => {
        return translatedPage.lang.substring(0, 2) === abbreviatedBrowserLanguage;
    });

    return alternatePage ? alternatePage.uid : null;
}

function redirectToPageLanguage({
    prismicPage,
    twoLetterLanguageCode,
    isHomePage,
}: {
    prismicPage?: PageDataType | null;
    twoLetterLanguageCode: string;
    isHomePage: boolean;
}) {
    let pageSlug: string | null = '';
    const query = window.location.search;

    if (prismicPage && !isHomePage) {
        pageSlug = getAlternatePage(prismicPage, twoLetterLanguageCode);

        // Fallback to english if no alternate pageSlug found
        if (pageSlug === null) {
            pageSlug = prismicPage.uid;
            twoLetterLanguageCode = SupportedLanguages.en;
        }
    }

    const relativeURL = `/${twoLetterLanguageCode}/${pageSlug}${query}`;

    navigate(relativeURL);
}

type Props = {
    location: any;
    data?: {
        prismicPage?: PageDataType;
    };
    children: any;
};

const App = ({ children, location, data }: Props) => {
    /**
     * Need to save the UTMs to cookies on initial app load in order to properly
     * attribute campaigns to sign ups
     */
    saveUTMsToCookies(UTMCookieSettings);

    const browserLanguage = navigator.language || 'en-US';
    const twoLetterLanguageCode = getTwoLetterLanguageCode(browserLanguage);
    const prismicPage = (data && data.prismicPage) || null;
    const isHomePage = (prismicPage && isHomePageHelper(prismicPage.uid)) || false;
    const pathsToBeConsideredForRedirect = [
        '/',
        '/login/',
        '/signup/',
        '/password/reset/',
        '/collaborator/register/',
    ];

    /**
     * Redirect non-english users (based on browser language) to a translated page for special pages
     * listed in pathsToBeConsideredForRedirect
     */
    if (
        pathsToBeConsideredForRedirect.includes(location.pathname) &&
        twoLetterLanguageCode !== 'en'
    ) {
        redirectToPageLanguage({ prismicPage, twoLetterLanguageCode, isHomePage });
    }

    return children;
};

export default App;
